import { useIsChuseokCallOff } from "goi_common";
import { Box, Stack } from "@mui/material";
import { parlorRegion } from "@/constants/parlorRegion";
import {
  ATypeCardView,
  call,
  ColorIcon,
  colors,
  getCdnImageSrc,
  GOI_WEB_URL,
  Link,
  FitWidthSmallButton,
  customEvent,
} from "goi_common";

import parlors from "goi_common/src/constants/parlors_detail.json";

const { targetSidos } = parlorRegion;

export default function Home() {
  const isChuseokCallOff = useIsChuseokCallOff();
  const regionParlors = parlors.filter((p) => targetSidos.includes(p.sido));
  return (
    <Stack>
      <Stack
        className="caption_12_sb"
        padding="0 16px"
        flexDirection="row"
        gap="16px"
        marginBottom="1px"
      >
        <Box padding="8px 0" borderBottom="3px solid black">
          장례식장 정보
        </Box>
        <Link
          className="gray600"
          style={{ textDecoration: "none", padding: "8px 0" }}
          href="/beneficiary/"
          event={{
            domain: "dggb",
            path: "home",
            trigger_and_target: "uv_basic_livelihood",
          }}
        >
          기초생활수급자
        </Link>
        <Link
          className="gray600"
          style={{ textDecoration: "none", padding: "8px 0" }}
          href={GOI_WEB_URL + "/service/flower/?utm_source=dogsound"}
          event={{
            domain: "dggb",
            path: "home",
            trigger_and_target: "uv_wreath_req-top",
          }}
        >
          화환 보내기
        </Link>
      </Stack>
      <Stack
        height="400px"
        padding="48px 20px"
        style={{
          background: `url(${getCdnImageSrc(
            "dogsound/dggb/homebackground.png"
          )})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>
            <Box className="subtitle_14_sb gray400">장례가 필요할 때</Box>
            <Box
              fontFamily="GmarketSans"
              fontSize="18px"
              fontWeight={700}
              className="white"
            >
              대구경북장례정보<br/><br/>[고이장례연구소]
              <span className="orange650">.</span>
            </Box>
          </Box>
          <Stack>
            <FitWidthSmallButton
              text="장례 견적 알아보기"
              backgroundColor={colors.orange650}
              href={GOI_WEB_URL + "/match/request/?utm_source=dogsound"}
              event={{
                domain: "dggb",
                path: "home",
                trigger_and_target: "uv_mth_req",
              }}
            />
          </Stack>
        </Stack>
      </Stack>

      <Stack
        flexDirection="row"
        justifyContent="center"
        gap="44px"
        padding="24px 0 60px"
      >
        {/* 2026 추석. 연휴에는 못 받는 전화라 이 버튼만 내린다. */}
        {!isChuseokCallOff && (
          <Stack
            alignItems="center"
            onClick={() => {
              call("1666-9784");
              customEvent({
                domain: "dggb",
                path: "home",
                trigger_and_target: "goi_call",
              });
            }}
          >
            <ColorIcon name="symbol-call" size={56} color="black" />
            <Box className="subtitle_14_sb">긴급 장례 상담</Box>
          </Stack>
        )}
        <Box height="65px" width="1px" style={{ background: colors.gray500 }} />
        <Link
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          href={GOI_WEB_URL + "/service/flower/?utm_source=dogsound"}
          event={{
            domain: "dggb",
            path: "home",
            trigger_and_target: "uv_wreath_req",
          }}
        >
          <ColorIcon name="flower-line" size={56} color="black" />
          <Box
            className="subtitle_14_sb black"
            style={{ textDecoration: "none" }}
          >
            화환 2시간 배송
          </Box>
        </Link>
      </Stack>
      <Stack alignItems="center" className="subtitle_16_b gray900" mb="6px">
        <h3>대구 · 경북 장례식장 리스트 </h3>
      </Stack>
      <Stack padding="0 20px" gap="10px">
        {regionParlors.map((res) => (
          <ATypeCardView
            key={res.companyname}
            name={res.companyname}
            href={`/funeral-places/${res.id}/price/`}
            descriptions={[
              `빈소 평균 비용 : ${Number(
                res.binso_average_charge
              ).toLocaleString()}원`,
            ]}
            imgSrc={res.images[0]?.url ? res.images[0].url : ""}
            event={{
              domain: "dggb",
              path: "home",
              trigger_and_target: "uv_funeral_detail",
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
}
